.resetButton {
  position: relative;
  align-self: end;
  font-weight: normal;
  font-size: var(--font-size-main-text);
  line-height: 22px;
  cursor: pointer;
  margin: 0;

  .is-button {
    @include button-styles;
    max-width: fit-content;
    min-width: 120px;
  }

  &.simple-button {
    padding-left: 25px;

    &:before {
      box-sizing: border-box;
      content: "\e938";
      display: block;
      position: absolute;
      font-family: var(--font-icons);
      font-size: 17px; /*icon*/
      line-height: 18px;
      top: 2px;
      left: 0;
    }

    &:hover {
      color: var(--color-red);
    }
  }
}
